import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { pick, prop } from 'js/utils/ramda.util';
import { usePortletSelector, usePortletConfig } from 'js/components/system/Portlet';

import * as helpers from '../helpers';
import { getLimitType } from '../../server';
import { LIMIT_ACTIONS } from '../../constants';

export const useInitialValues = () => {
    const {
        actualLimits,
        config: { defaultFieldValues }
    } = usePortletSelector(pick(['actualLimits', 'config']));
    const { portletType } = usePortletConfig();
    const betLossLimitActions = useAppSelector(prop('betLossLimitActions'));
    const typeLimitActions = betLossLimitActions[`${getLimitType(portletType)}limitActions`];

    return useMemo(() => {
        const fetchLimitsTimestamp = Date.now();
        const limitActions = helpers.getLimitActions(typeLimitActions);
        const userAction = helpers.getUserLimitAction(actualLimits);
        const action = limitActions.length < 2
            ? limitActions[0] || LIMIT_ACTIONS.MESSAGE
            : limitActions.includes(userAction) ? userAction : '';
        const actualFieldValues = Object.keys(actualLimits).reduce((acc, key) => ({
            ...acc,
            [key]: actualLimits[key].limit?.amount
        }), {});

        return {
            ...defaultFieldValues,
            ...actualFieldValues,
            fetchLimitsTimestamp,
            action
        };
    }, [actualLimits, defaultFieldValues, typeLimitActions]);
};
